import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import initReducer from './components/init/initReducer';
import signinReducer from './components/signin/signinReducer';
import signupReducer from './components/signup/signupReducer';
import commandsReducer from './components/commands/commandsReducer';
import receptionsReducer from './components/receptions/receptionsReducer';
import operationReducer from './components/operations/operationsReducer';
import courseReducer from './components/course/courseReducer';
import vouchersReducer from './components/vouchers/vouchersReducer';
import stockReducer from './components/stock/stockReducer';
import userProfileReducer from './components/userProfile/userProfileReducer';
import importCommandsReducer from './components/ImportCommands/ImportCommandReducer';
import mergeCommandsReducer from './components/mergeCommands/mergeCommmandsReducer';
import addCommandReducer from './components/addCommand/addCommandReducer';
import importProductReducer from './components/importProducts/other/ImportProductsReducer';
import dashboardReducer from './components/dashboard/dashboardReducer';

export default combineReducers({
  init: initReducer,
  form: formReducer,
  signin: signinReducer,
  signup: signupReducer,
  commands: commandsReducer,
  receptions: receptionsReducer,
  operations: operationReducer,
  course: courseReducer,
  vouchers: vouchersReducer,
  stock: stockReducer,
  userProfile: userProfileReducer,
  importCommands: importCommandsReducer,
  mergeCommands: mergeCommandsReducer,
  addCommand: addCommandReducer,
  importProducts: importProductReducer,
  dashboard: dashboardReducer
});
